import React from 'react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { useDispatch } from 'react-redux';
import { doShowLogs } from 'state/restoreDeletedBusiness/actions';
import MainPage from 'pages/RestoreDeletedBusiness/MainPage';

function RestoreDeletedBusiness() {
  const dispatch = useDispatch();

  return (
    <>
      <SemanticToastContainer />
      <h1>Restore Deleted Business</h1>
      <br />
      <MainPage onShowLogButtonClicked={() => dispatch(doShowLogs())} />
    </>
  );
}

export default RestoreDeletedBusiness;
